var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "default-loading-container" }, [
    _c(
      "div",
      { staticClass: "col-12 justify-content-center loading-spinner" },
      [
        _c(
          "div",
          { staticClass: "spinner-border", attrs: { role: "status" } },
          [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(_vm._s(_vm.translate.home.loading) + "...")
            ])
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.translate.home.loading) + "...")])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53c49301", { render: render, staticRenderFns: staticRenderFns })
  }
}